export default "__VITE_ASSET__CgQUYwxy__"